export default {
  http: {
    success: { code: 200, msg: '' },
    notFound: { code: 404, msg: '' },
  },
  general: {
    success: { code: 0, msg: 'OK' },
    invalidCmd: { code: 10, msg: '不正なコマンドです' },
  },
  auth: {
    loginFailed: { code: 20, msg: 'ログインに失敗しました' },
    invalidToken: { code: 21, msg: '不正なユーザからのリクエストです' },
    passwordRestRequired: { code: 22, msg: 'パスワードの再設定が必要です' },
    passwordForceChangeRequired: { code: 23, msg: '初期パスワードの変更が必要です' },
    verifyRequired: { code: 24, msg: '検証コードによる確認が必要です' },
    resetPasswordProcessFailed: { code: 25, msg: 'パスワードリセットに失敗しました' },
    forgotPasswordProcessFailed: { code: 26, msg: 'パスワード再設定プロセスの起動に失敗しました' },
  },
};
